<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3" :class="{'col-6': !isPaid}" v-for="(media, index) in medias" :key="media.id">
        <Media :media="media"
               :index="index"
               :is-paid="isPaid"
               :digital-item-id="digitalItemId"
               :gallery="gallery"
               @firstVisible="$emit('nextPage')"
               @select="$emit('select', $event)"/>
      </div>
    </div>

    <!-- Load more button -->
    <div style="height: 36px" class="text-center mt-2 mb-4">
      <div v-show="paginate">
        <view-loader :padding-classes="'py-2'" v-if="loading"/>
        <b-button @click="$emit('nextPage')" variant="primary" size="sm" v-else>
          {{ $t('pages.checkins_detail.load_more') }}
          <Icon name="plus" width="16" vertical-align="sub"/>
        </b-button>
      </div>
    </div>
  </div>
</template>


<script>
import ViewLoader from "@/components/ViewLoader.vue";
import Media from "@/domain/media/galleries/medias/Media.vue";

export default {
  name: "VerticalMedias",
  components: {Media, ViewLoader},
  emits: ['nextPage', 'select'],
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    paginate: {
      type: Boolean,
      required: true
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: true
    }
  }
}
</script>


<style scoped>

</style>